const regionMap = {
  'eu-1': 'Europe',
  'eu-private-1': 'Stg',
  us1: 'US',
  usscif1: 'SCIF',
};

export default regionMap;
